import React from 'react';
import { useSelector } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import skuHelpers from 'utils/skuHelpers';

const RedesignedLoveCount = ({ product, skuId }) => {
    const { productDetails = {}, regularChildSkus } = product || {};
    const shoppingListIds = useSelector(state => state.loves.shoppingListIds) || [];

    const productSkuIds = [skuId, ...(regularChildSkus || []).map(s => s.skuId)];
    const userHasLovedProduct = shoppingListIds.some(id => productSkuIds.includes(id));

    if (!(productDetails.lovesCount > 0) && !userHasLovedProduct) {
        return null;
    }

    const lovesCount = skuHelpers.getProductLovesCount({
        regularChildSkus,
        lovesCount: productDetails.lovesCount,
        skuId
    });

    return (
        <Box
            fontSize='xs'
            lineHeight='tight'
        >
            {lovesCount}
        </Box>
    );
};

export default wrapFunctionalComponent(RedesignedLoveCount, 'RedesignedLoveCount');
